import { useMemo } from 'react';

import { CareerPath } from '@backrs_ui/common-ui';

import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  ProfileFields,
  ProfileValueOption,
  StoryDocument,
  useFetchProfileValueOptionsQuery,
  UserProfileResponse,
} from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { optionResolvers } from '../configs/resolvers.config';

type UseGetSelectedOptionsArgs = Readonly<{
  userProfile?: UserProfileResponse;
  isEditView: boolean;
}>;

export const useGetSelectedOptions = ({ userProfile, isEditView }: UseGetSelectedOptionsArgs) => {
  const careerPaths = useAppSelector((state) => state.careerPath.careerPaths);

  const { data: profileOptions } = useFetchProfileValueOptionsQuery(undefined);

  return useMemo(() => {
    if (!userProfile?.profile || !profileOptions || careerPaths.length === 0) {
      return () => [];
    }

    return (
      key: ProfileFields,
    ): (string | number | ProfileValueOption | CareerPath | StoryDocument)[] => {
      const resolver = optionResolvers[key];

      return resolver ? resolver(userProfile, { ...profileOptions, careerPaths }, isEditView) : [];
    };
  }, [userProfile, profileOptions, careerPaths, isEditView]);
};
